import React, { useContext, useState } from 'react';
import Table from '../../../Utils/Grid';
import { standardActions } from '../../../Utils/Grid/StandardActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import Search from '../../../Utils/Search';
import LoaderContext from '../../../../context/LoaderContext';
import useList from '../../../../hooks/useList';
import useDelete from '../../../../hooks/useDelete';
import { DateTime } from 'luxon';
import UserContext from '../../../../context/UserContext';
import {
    SCHOOL_COORDINATOR,
    INVITED,
    ASSISTANT,
    TRAINER,
    SCHOOL_TRAINER,
    SUPER_ADMIN,
    COORDINATOR
} from '../../../../../utility/constants'

export default function TrainingPlans() {
    const { loader } = useContext(LoaderContext);
    const { data, getData, page } = useList('training_plan');
    const [search, setSearch] = useState(null);
    const { deleteData } = useDelete('training_plan');
    const { user }= useContext(UserContext);

    return (
        <React.Fragment>
            <div className="pt-5" />
            <div className="d-flex flex-column flex-md-row justify-content-between">
                <h1 className="title-text">Planes de formación</h1>
                { (user.type === SUPER_ADMIN || user.type === COORDINATOR) &&(
                <Link to="/training_plan/create" className="btn btn-primary">
                    Registrar Plan de formación
                </Link>
                )}
            </div>
            <Search
                onSearch={(value) => {
                    getData(1, {
                        search: value,
                    }).then();
                    setSearch(value);
                }}
                placeholder="Buscar por nombre ..."
            />
            <Table
                className="mt-5"
                data={data}
                loading={loader}
                onPageChange={(page) => getData(page, { search: search })}
                page={page}
            >
                <TableHeaderColumn
                    dataField="id"
                    dataAlign="center"
                    width="8rem"
                    isKey
                    dataFormat={standardActions({
                        view: '/training_plan',
                        update_training: '/training_plan',
                        erase: (id) => deleteData(id, getData),
                        type:user.type,
                    })}
                >
                    Herramientas
                </TableHeaderColumn>
                <TableHeaderColumn dataField="name" width="10rem">
                    Nombre
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="modified"
                    width="10rem"
                    dataFormat={(value) => {
                        const dateTime = DateTime.fromISO(value);
                        return dateTime.toLocaleString(DateTime.DATETIME_SHORT);
                    }}
                >
                    Ultima modificación
                </TableHeaderColumn>
            </Table>
        </React.Fragment>
    );
}
